export default {
  name: "TextField",
  props: {
    rules: {
      default: () => [],
      type: Array,
    },
    mask: {
      default: false,
    },
    type: {
      default: "text",
      type: String,
    },
    suffix: {
      default: "",
      type: String,
    },
    counter: {
      default: false,
    },
    appendIcon: {
      default: "",
      type: String,
    },
    responsive: {
      default: () => {
        return {
          cols: "12",
          sm: "12",
          md: "12",
          lg: "12",
        };
      },
      type: Object,
    },
    vModel: {
      required: true,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    title: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
  },

  created() {
    this.value = this.vModel;
  },

  methods: {
    emitAppend() {
      this.$emit("appendClicked");
    },
    emitBlur() {
      this.$emit("on-blur");
    }
  },

  watch: {
    value() {
      this.$emit("input", this.value);
    },

    vModel() {
      this.value = this.vModel;
    },
  },

  data: () => ({
    value: null,
  }),
};
